import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserType } from "../../../types/User";

const initialState: UserType = {
    id: '',
    name: '',
    userName:'',
    email: '',
    bi: '',
    nuit: '',
    phoneNumber: '',
    dateOfBirth: '',
    gender: 'M',
    countryDescription:'MOZ',
    isForeign:false
};

export const userSlice = createSlice({
    name: "userForm",
    initialState,
    reducers: {
        setUserData: (
            state, action: PayloadAction<UserType>,
        ) => {
            return { ...state, ...action.payload };
        },
        resetUserData: () => {
            return initialState
        }
    }
});
export const { setUserData, resetUserData } = userSlice.actions;
export default userSlice.reducer;